module.exports = {
  colors: {
    primary: "#16283F",
    primaryText: "#EDEEE9",
    borderColor: "#C4C4C4",
    backgroundColor: "#EDEEE9",
    alternateTextColor: "#999999"
  },
  styles: {
    "b-default": "background: #FFFFFF; color: #16283F;",
    "b-success": "background: #8D957C; color: #FFFFFF;",
    "b-danger": "background: #A36257; color: #FFFFFF;",
    "b-primary": "background: #40677E; color: #FFFFFF;",
    "b-secondary": "background: #564D8C; color: #FFFFFF;",
    "b-warning": "background: #FFAD20; color: #16283F;"
  }
};



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/theme.js